import { Variants } from 'framer-motion';
import { CARD_ANIMATION } from '../../../BeFi20.meta';

export const ANSWER_OPTIONS = [
  { label: 'Strongly Disagree', value: 0, keyboardShortcut: 'a' },
  { label: 'Slightly Disagree', value: 1, keyboardShortcut: 'b' },
  { label: 'Slightly Agree', value: 2, keyboardShortcut: 'c' },
  { label: 'Strongly Agree', value: 3, keyboardShortcut: 'd' },
];

interface VariantProps {
  direction: 'forward' | 'backward';
  isMobile: boolean;
}

export const animationVariants: Variants = {
  enter: ({ direction, isMobile }: VariantProps) => {
    if (isMobile) {
      if (direction === 'forward') {
        return {
          x: '100vw',
        };
      }

      return {
        opacity: 0,
        scale: 0.5,
      };
    }

    return {
      scale:
        direction === 'forward' ? 1 + CARD_ANIMATION.scaleFactor : 1 - CARD_ANIMATION.scaleFactor,
      opacity: 0,
      x: '-50%',
      y: '-50%',
    };
  },

  visible: ({ direction, isMobile }: VariantProps) => {
    if (isMobile) {
      if (direction === 'forward') {
        return {
          x: 0,
          opacity: 1,
        };
      }

      return {
        scale: 1,
        opacity: 1,
      };
    }

    return {
      scale: 1,
      opacity: 1,
    };
  },

  exit: ({ direction, isMobile }: VariantProps) => {
    if (isMobile) {
      if (direction === 'forward') {
        return {
          opacity: 0,
          scale: 0.5,
        };
      }

      return {
        x: '100vw',
      };
    }

    return {
      scale:
        direction === 'forward' ? 1 - CARD_ANIMATION.scaleFactor : 1 + CARD_ANIMATION.scaleFactor,
      opacity: 0,
    };
  },
};
